import React from 'react'
import ForgotPasswordBox from './ForgotPasswordBox'
import Hero from '../generic/Hero'
import Columns from '../generic/Columns'

const ForgotPasswordPage = (props) => {
  return (
    <Hero>
      <Columns>
        <ForgotPasswordBox />
      </Columns>
    </Hero>
  )
}

export default ForgotPasswordPage



// WEBPACK FOOTER //
// ./src/components/forgot-password/ForgotPasswordPage.js